


















































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePengkajianAkhirHayat } from "@/store/modules/PengkajianAkhirHayatStore";
import PengkajianAkhirHayatSvc from "@/services/PengkajianAkhirHayat";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPengkajianAkhirHayat extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  isEditing = false;
  editingId: number | null = null;
  saving = false;
  formValid = false;
  dateMenu = false;
  timeMenu = false;
  panels: number[] = [0, 1];
  detailPanels: number[] = [];
  detailData: any = null;
  modalTtd = false;
  signing = false;
  ttdHint = "";
  modalKeluarga = false;
  keluargaNama = "";

  form: any = this.getEmptyForm();

  headers = [
    { text: "Tanggal", value: "tgl_pengkajian", width: "15%" },
    { text: "Pukul", value: "jam_pengkajian", width: "10%" },
    { text: "Pengkaji", value: "pengkaji_nama", width: "25%" },
    { text: "Status", value: "status", width: "15%" },
    { text: "Aksi", value: "aksi", sortable: false, width: "20%" }
  ];

  kesadaranOptions = ["Compos Mentis", "Somnolen", "Sopor", "Koma"];

  usahaNafasOptions = [
    { text: "Dipneu", value: "dipneu" },
    { text: "Takipneu", value: "takipneu" },
    { text: "Bradipneu", value: "bradipneu" },
    { text: "Apneu", value: "apneu" }
  ];

  usahaNafasMap: Record<string, string> = {
    dipneu: "Dipneu", takipneu: "Takipneu", bradipneu: "Bradipneu", apneu: "Apneu"
  };

  spiritualOptions = [
    { text: "Putus Asa", value: "putus_asa" },
    { text: "Perasaan Bersalah", value: "bersalah" },
    { text: "Perasaan Menderita", value: "menderita" },
    { text: "Kebutuhan untuk dimaafkan", value: "dimaafkan" }
  ];

  spiritualMap: Record<string, string> = {
    putus_asa: "Putus Asa", bersalah: "Perasaan Bersalah", menderita: "Perasaan Menderita", dimaafkan: "Kebutuhan untuk dimaafkan"
  };

  risikoOptions = [
    { text: "Penolakan", value: "penolakan" },
    { text: "Marah", value: "marah" },
    { text: "Belum Menerima", value: "belum_menerima" },
    { text: "Depresi", value: "depresi" },
    { text: "Menerima", value: "menerima" }
  ];

  risikoMap: Record<string, string> = {
    penolakan: "Penolakan", marah: "Marah", belum_menerima: "Belum Menerima", depresi: "Depresi", menerima: "Menerima"
  };

  manajemenFields = [
    { label: "Obat-obatan", field: "manajemen_obat", ket: "manajemen_obat_keterangan" },
    { label: "Ventilasi Mekanik", field: "manajemen_ventilasi", ket: "manajemen_ventilasi_keterangan" },
    { label: "RKP", field: "manajemen_rkp", ket: "manajemen_rkp_keterangan" },
    { label: "Defibrilator", field: "manajemen_defibrilator", ket: "manajemen_defibrilator_keterangan" },
    { label: "Lain-lain", field: "manajemen_lainnya", ket: "manajemen_lainnya_keterangan" }
  ];

  get loading() { return storePengkajianAkhirHayat.loading; }
  get stateList() { return storePengkajianAkhirHayat.list; }

  get canSignPengkaji() {
    if (this.readOnly) return false;
    if (!this.detailData || this.detailData.signed_pengkaji) return false;
    return true;
  }

  get canMarkKeluarga() {
    if (this.readOnly) return false;
    if (!this.detailData || this.detailData.signed_keluarga) return false;
    return this.detailData.signed_pengkaji;
  }

  getEmptyForm() {
    return {
      tgl_pengkajian: localISODate(),
      jam_pengkajian: new Date().toTimeString().substr(0, 5),
      kesadaran: null,
      nadi: null,
      rr: null,
      td_sistolik: null,
      td_diastolik: null,
      suhu: null,
      mual: null,
      batuk: null,
      usaha_nafas: [],
      kesulitan_bernafas: null,
      refleks_cahaya: null,
      refleks_kornea: null,
      nadi_kekuatan: null,
      nadi_frekuensi: null,
      ada_faktor_gejala: null,
      faktor_gejala_keterangan: "",
      manajemen_obat: null,
      manajemen_obat_keterangan: "",
      manajemen_ventilasi: null,
      manajemen_ventilasi_keterangan: "",
      manajemen_rkp: null,
      manajemen_rkp_keterangan: "",
      manajemen_defibrilator: null,
      manajemen_defibrilator_keterangan: "",
      manajemen_lainnya: null,
      manajemen_lainnya_keterangan: "",
      orientasi_spiritual: null,
      orientasi_spiritual_keterangan: "",
      spiritual_pasien: [],
      spiritual_keluarga: [],
      hubungan_keluarga: null,
      dukungan_keluarga: null,
      respon_pasien: null,
      respon_keluarga: null,
      butuh_bantuan: null,
      butuh_bantuan_keterangan: "",
      perawatan_alternatif: null,
      perawatan_alternatif_keterangan: "",
      risiko_keluarga: []
    };
  }

  openForm() {
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
    this.panels = [0, 1];
    this.showForm = true;
  }

  openEdit(item: any) {
    this.isEditing = true;
    this.editingId = item.id;
    this.form = {
      tgl_pengkajian: item.tgl_pengkajian,
      jam_pengkajian: item.jam_pengkajian,
      kesadaran: item.kesadaran,
      nadi: item.nadi,
      rr: item.rr,
      td_sistolik: item.td_sistolik,
      td_diastolik: item.td_diastolik,
      suhu: item.suhu,
      mual: item.mual,
      batuk: item.batuk,
      usaha_nafas: item.usaha_nafas || [],
      kesulitan_bernafas: item.kesulitan_bernafas,
      refleks_cahaya: item.refleks_cahaya,
      refleks_kornea: item.refleks_kornea,
      nadi_kekuatan: item.nadi_kekuatan,
      nadi_frekuensi: item.nadi_frekuensi,
      ada_faktor_gejala: item.ada_faktor_gejala,
      faktor_gejala_keterangan: item.faktor_gejala_keterangan || "",
      manajemen_obat: item.manajemen_obat,
      manajemen_obat_keterangan: item.manajemen_obat_keterangan || "",
      manajemen_ventilasi: item.manajemen_ventilasi,
      manajemen_ventilasi_keterangan: item.manajemen_ventilasi_keterangan || "",
      manajemen_rkp: item.manajemen_rkp,
      manajemen_rkp_keterangan: item.manajemen_rkp_keterangan || "",
      manajemen_defibrilator: item.manajemen_defibrilator,
      manajemen_defibrilator_keterangan: item.manajemen_defibrilator_keterangan || "",
      manajemen_lainnya: item.manajemen_lainnya,
      manajemen_lainnya_keterangan: item.manajemen_lainnya_keterangan || "",
      orientasi_spiritual: item.orientasi_spiritual,
      orientasi_spiritual_keterangan: item.orientasi_spiritual_keterangan || "",
      spiritual_pasien: item.spiritual_pasien || [],
      spiritual_keluarga: item.spiritual_keluarga || [],
      hubungan_keluarga: item.hubungan_keluarga,
      dukungan_keluarga: item.dukungan_keluarga,
      respon_pasien: item.respon_pasien,
      respon_keluarga: item.respon_keluarga,
      butuh_bantuan: item.butuh_bantuan,
      butuh_bantuan_keterangan: item.butuh_bantuan_keterangan || "",
      perawatan_alternatif: item.perawatan_alternatif,
      perawatan_alternatif_keterangan: item.perawatan_alternatif_keterangan || "",
      risiko_keluarga: item.risiko_keluarga || []
    };
    this.panels = [0, 1];
    this.showForm = true;
  }

  closeForm() {
    this.showForm = false;
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form
      };

      let resp;
      if (this.isEditing && this.editingId) {
        resp = await PengkajianAkhirHayatSvc.update(this.editingId, payload);
      } else {
        resp = await PengkajianAkhirHayatSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pengkajian berhasil disimpan");
        this.closeForm();
        this.$emit("saved");
        storePengkajianAkhirHayat.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  openDetail(item: any) {
    this.detailData = item;
    this.detailPanels = [];
    this.showDetail = true;
  }

  // Tanda Tangan Pengkaji
  async openTtd() {
    appModule.addMsgTtd("");
    this.ttdHint = "";
    this.modalTtd = true;
    try {
      const resp = await PengkajianAkhirHayatSvc.ttdStatus();
      const st = resp?.data?.data;
      if (st) {
        this.ttdHint = st.has_pin
          ? "Masukkan PIN TTE (6 digit), bukan password akun."
          : "Masukkan password akun Anda (PIN TTE belum didaftarkan).";
        if (!st.has_signature) {
          appModule.addMsgTtd(
            "Anda belum mengunggah berkas tanda tangan. Buka menu Profil untuk mengunggahnya terlebih dahulu."
          );
        }
      }
    } catch {
      // 
    }
  }

  async passTtd(password: string) {
    this.signing = true;
    try {
      const resp = await PengkajianAkhirHayatSvc.signPengkaji(this.detailData.id, { password });
      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Pengkaji");
        appModule.addMsgTtd("");
        await storePengkajianAkhirHayat.getByRegister(this.register);
        this.refreshDetail();
      } else {
        appModule.addMsgTtd(resp.data.message);
      }
    } catch (e) {
      const msg = (e as { response?: { data?: { message?: string } } })?.response?.data?.message;
      appModule.addMsgTtd(msg ?? "Gagal menandatangani. Silakan coba lagi.");
    } finally {
      this.signing = false;
    }
  }

  // Tandai Keluarga
  openMarkKeluarga() {
    this.keluargaNama = this.detailData?.keluarga_nama || "";
    this.modalKeluarga = true;
  }

  async submitMarkKeluarga() {
    const resp = await PengkajianAkhirHayatSvc.markKeluarga(this.detailData.id, {
      keluarga_nama: this.keluargaNama
    });
    if (resp.data.status == "1") {
      this.modalKeluarga = false;
      appModule.NoticeDelay("Berhasil menandai Keluarga");
      await storePengkajianAkhirHayat.getByRegister(this.register);
      this.refreshDetail();
    }
  }

  async refreshDetail() {
    try {
      const resp = await PengkajianAkhirHayatSvc.find(this.detailData.id);
      if (resp.data.status == "1") {
        this.detailData = resp.data.data;
      }
    } catch {
      // silent
    }
  }

  alasanTidakBisaHapus(item: any): string {
    if (this.readOnly) return "Rekam medis sudah terkunci (read-only)";
    return alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.signed_pengkaji, penandaTanganId: item.pengkaji_user_id },
        { ditandatangani: item.signed_keluarga, penandaTanganId: null }
      ],
      userModule.user?.id
    );
  }

  async remove(item: any) {
    if (this.alasanTidakBisaHapus(item)) return;
    const q = confirm("Anda yakin akan menghapus pengkajian ini?");
    if (q) {
      const resp = await PengkajianAkhirHayatSvc.destroy(item.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storePengkajianAkhirHayat.getByRegister(this.register);
      }
    }
  }

  cetakPdf(item: any) {
    PengkajianAkhirHayatSvc.print(item.id);
  }

  // Status helpers
  isLocked(item: any) {
    if (this.readOnly) return true;
    return item.signed_pengkaji && item.signed_keluarga;
  }

  getStatusColor(item: any) {
    if (item.signed_pengkaji && item.signed_keluarga) return "green";
    if (item.signed_pengkaji || item.signed_keluarga) return "orange";
    return "grey";
  }

  getStatusLabel(item: any) {
    if (item.signed_pengkaji && item.signed_keluarga) return "Terkunci";
    if (item.signed_pengkaji) return "TTD Pengkaji";
    if (item.signed_keluarga) return "TTD Keluarga";
    return "Belum TTD";
  }

  // Format helpers
  formatBoolean(val: boolean | null) {
    if (val === true) return "Ya";
    if (val === false) return "Tidak";
    return "-";
  }

  formatBooleanAda(val: boolean | null) {
    if (val === true) return "Ada";
    if (val === false) return "Tidak Ada";
    return "-";
  }

  formatEnum(val: string | null) {
    if (!val) return "-";
    return val.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
  }

  formatArray(arr: string[] | null, map: Record<string, string>) {
    if (!arr || !arr.length) return "-";
    return arr.map(v => map[v] || v).join(", ");
  }
}
